import { all, call, put, select, takeLatest } from "redux-saga/effects";
import axios, { AxiosResponse } from "axios";
import { actionTypes, integrationsActions } from "../store/reducers/integrationsReducer";
import { generalActions } from "../store/reducers/generalReducer";
import { StateType } from "../store";
import { API_URL } from "../../constants/base";

interface ChabadOrgStatusResponse {
  connected: boolean;
  connectedAt?: string;
  salesforceInstanceUrl?: string;
}

interface DisconnectResponse {
  message: string;
}

function* getChabadOrgStatusWorker(): Generator<any, void, any> {
  try {
    yield put(integrationsActions.setIntegrationsLoading(true));

    const token = yield select((state: StateType) => state.authStore.token);

    const response: AxiosResponse<ChabadOrgStatusResponse> = yield call(
      axios.get,
      `${API_URL}/api/auth/chabad-org/status`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    yield put(integrationsActions.setChabadOrgStatus(response.data));
  } catch (error: any) {
    yield put(
      integrationsActions.setIntegrationsError(
        error.response?.data?.message || "Failed to fetch connection status"
      )
    );
    yield put(
      generalActions.errorAC({
        message: "Failed to fetch Chabad.org connection status",
        type: "error",
      })
    );
  }
}

function* disconnectChabadOrgWorker(): Generator<any, void, any> {
  try {
    yield put(integrationsActions.setIntegrationsLoading(true));

    const token = yield select((state: StateType) => state.authStore.token);

    const response: AxiosResponse<DisconnectResponse> = yield call(
      axios.delete,
      `${API_URL}/api/auth/chabad-org/disconnect`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    yield put(integrationsActions.setChabadOrgStatus({ connected: false }));

    yield put(
      generalActions.successAC({
        message: response.data.message || "Successfully disconnected from Chabad.org",
        type: "success",
      })
    );
  } catch (error: any) {
    // Handle 403 Forbidden error specifically
    if (error.response?.status === 403) {
      yield put(
        generalActions.errorAC({
          message: "Only super administrators can manage integrations",
          type: "error",
        })
      );
      yield put(
        integrationsActions.setIntegrationsError(
          "Only super administrators can manage integrations"
        )
      );
    } else {
      yield put(
        integrationsActions.setIntegrationsError(
          error.response?.data?.message || "Failed to disconnect"
        )
      );
      yield put(
        generalActions.errorAC({
          message: error.response?.data?.message || "Failed to disconnect from Chabad.org",
          type: "error",
        })
      );
    }
  }
}

export function* integrationsWatcher() {
  yield all([
    takeLatest(actionTypes.GET_CHABAD_ORG_STATUS_TRIGGER, getChabadOrgStatusWorker),
    takeLatest(actionTypes.DISCONNECT_CHABAD_ORG_TRIGGER, disconnectChabadOrgWorker),
  ]);
}
